<template>
  <div class="p-card-title">
    <span class="c-card-title__text"><slot /></span>
  </div>
</template>
<script>
export default {
  name: 'CardTitle',
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.p-card-title {
  display: inline-block;
  height: 28px;
  line-height: 28px;
  min-width: 50px;
  background: url("~@/views/pt/images/exhibition-icon.png") no-repeat center
    left;
  background-size: 21px;
  padding-left: 30px;
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #e3e2ff;
}
</style>
